import PropTypes from 'prop-types';
import {createUseStyles, useTheme} from 'react-jss';
import {connect} from 'react-redux';
import Translation from '../../v2/lang/Translation';
import {deliveryOptionHasTaxPrice} from '../../v2/selectors/DeliveryOptionSelectorsUtils';
import {
  getDeliveryGroupSelections,
  getMaxPriceGroupIndex,
  isOptionalGroupUsed,
} from '../../v2/selectors/DeliveryOptionsSelectors/DeliveryOptionsSelectors';
import {getSettings} from '../../v2/selectors/selectors';
import Spacing from '../../v2/style-helper/Spacing';
import DeliveryOptionProductImageContainer
  from './DeliveryOptionProductImageContainer/DeliveryOptionProductImageContainer';
import DeliveryOptionShipmentContents from './DeliveryOptionShipmentContents/DeliveryOptionShipmentContents';

const useStyles = createUseStyles({
  deliveryGroup: {
    padding: [Spacing.double, 0],
    '&:first-child': {
      paddingTop: 0,
    },
    borderBottom: '2px solid #f2f2f2',
    '&:last-child': {
      borderBottom: 'none',
      paddingBottom: 0,
    },
  },
  deliveryType: {
    marginBottom: Spacing.single,
    fontWeight: props => props.theme.core.boldFontWeight,
  },
});

export function CollapsedDeliveryOptionSection(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  
  const getDeliveryOptionTypeKey = (deliveryOptionTypeKey, deliveryOptionId) => {
    if (props.settings[`site_specific_delivery_key_for_${deliveryOptionId}`]) {
      return props.settings[`site_specific_delivery_key_for_${deliveryOptionId}`]?.type || deliveryOptionTypeKey;
    }
    
    return deliveryOptionTypeKey;
  };
  
  return (
    // div needed to ensure last child styling effective.
    <div data-test="CollapsedDeliveryOptionSection">
      {props.deliveryGroups.map((deliveryGroup, index) => (
        (!deliveryGroup.optional || deliveryGroup.used) && (
          <div className={classes.deliveryGroup}>
            <div
              key={index}
              style={(props.getMaxPriceGroupIndex === deliveryGroup.id) ? {order: 0} : {order: 1}}
            >
              {props.deliveryGroups.length > 1 && (
                <DeliveryOptionProductImageContainer
                  basketItems={deliveryGroup.basketItems}
                  isFastTrackGroup={deliveryGroup.isFastTrackGroup}
                  shouldFilterOutFastDeliveryItems={!deliveryGroup.isFastTrackGroup && props.isOptionalGroupUsed}
                  groupId={deliveryGroup.id}
                />
              )}
              
              <p className={classes.deliveryType} data-test="CollapsedDeliveryOptionSection_type">
                <Translation>
                  {getDeliveryOptionTypeKey(
                    deliveryGroup.deliveryOption.translationKeys.type, deliveryGroup.deliveryOption.id
                  )}
                </Translation>
              </p>
              
              <DeliveryOptionShipmentContents
                groupId={deliveryGroup.id}
                index={index}
                deliveryOption={deliveryGroup.deliveryOption}
                type={deliveryGroup.deliveryOption.translationKeys.type}
                fastTrackProducts={deliveryGroup.fastTrackItem}
                taxable={deliveryOptionHasTaxPrice(deliveryGroup.deliveryOption)}
                isOptionalGroup={deliveryGroup.optional}
                hasToggle={!!(deliveryGroup.deliveryOption.fastDelivery && deliveryGroup.optional)}
              />
            </div>
          </div>
        )
      ))}
    </div>
  );
}

CollapsedDeliveryOptionSection.propTypes = {
  deliveryGroups: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    optional: PropTypes.bool.isRequired,
    fastTrackItem: PropTypes.array,
    basketItems: PropTypes.array,
    isFastTrackGroup: PropTypes.bool.isRequired,
    used: PropTypes.bool.isRequired,
    deliveryOption: PropTypes.shape({
      translationKeys: PropTypes.shape({
        type: PropTypes.string.isRequired,
      }),
    }).isRequired,
  })),
  settings: PropTypes.object,
  getMaxPriceGroupIndex: PropTypes.number.isRequired,
  isOptionalGroupUsed: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  deliveryGroups: getDeliveryGroupSelections(state),
  getMaxPriceGroupIndex: getMaxPriceGroupIndex(state),
  isOptionalGroupUsed: isOptionalGroupUsed(state),
  settings: getSettings(state),
});

export default connect(mapStateToProps)(CollapsedDeliveryOptionSection);
